var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgIUploadIcon = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33342 0.833374H2.00008C1.26675 0.833374 0.673415 1.43337 0.673415 2.16671L0.666748 12.8334C0.666748 13.5667 1.26008 14.1667 1.99341 14.1667H10.0001C10.7334 14.1667 11.3334 13.5667 11.3334 12.8334V4.83337L7.33342 0.833374ZM10.0001 12.8334H2.00008V2.16671H6.66675V5.50004H10.0001V12.8334ZM3.33341 9.50671L4.27341 10.4467L5.33342 9.39337V12.1667H6.66675V9.39337L7.72675 10.4534L8.66675 9.50671L6.00675 6.83337L3.33341 9.50671Z",
    fill: "#3C3ADA"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIUploadIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/i_upload_icon.398a3c74.svg";
export { ForwardRef as ReactComponent };